/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIReportCategory } from '@/models/api/report-category.model'

const resource = {
    main: 'services',
    module: 'report-categories'
}
export class ReportCategoriesServices {
    public static getReportCategories () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getReportCategoriesPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getReportCategoriesById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createReportCategories (params: APIReportCategory) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editReportCategories (params: APIReportCategory) {
        return service.put(`${resource.main}/${resource.module}/${params.categoryId}`, params)
    }

    public static deleteReportCategories (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }
}
